export default "__VITE_ASSET__B4SL0rPw__"